import { NavLink, Link } from "react-router";
import { FiHome, FiPlus, FiUser } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import AccountMenu from "./AccountMenu";

export default function AppBottomNavigation() {
  const { userId } = useAuth();
  return <nav className="app-bottom-nav" aria-label="App bottom navigation">
    <NavLink to={userId ? "/explore" : "/"} end className="group-bottom-action"><FiHome aria-hidden="true" /><span>Home</span></NavLink>
    {userId ? <button type="button" onClick={() => window.dispatchEvent(new Event("community:create"))} className="group-bottom-action"><FiPlus aria-hidden="true" /><span>Create channel</span></button> : <Link to="/login" className="group-bottom-action"><FiPlus aria-hidden="true" /><span>Create channel</span></Link>}
    {userId ? <AccountMenu bottom /> : <Link to="/login" className="group-bottom-action"><FiUser aria-hidden="true" /><span>Profile</span></Link>}
  </nav>;
}
